import {Component, NgZone, OnInit, ViewEncapsulation} from '@angular/core';
import {DevicesService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from '../../shared/services/api.service';
import {DocumentType, UserPermission, UserPlatformRole} from '../../shared/models/user';
import {Place} from '../../shared/models/place';
import {CartService} from '../../shared/services/cart.service';
import {environment} from 'src/environments/environment';
import {RequestService} from '../../shared/services/request.service';
import {ScanDocumentService} from 'src/app/shared/services/scan-document.service';
import {FormBuilder, FormGroup} from '@angular/forms';

declare const window: any;
const permissions = window.cordova?.plugins?.permissions;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {

  userRoles = UserPlatformRole;
  form: FormGroup;

  constructor(public nav: NavigateService,
              public api: ApiService,
              public cart: CartService,
              public scanDocument: ScanDocumentService,
              public request: RequestService,
              private formBuilder: FormBuilder,
              private loader: LoaderService,
              private lang: LangService,
              private deviceService: DevicesService,
              private zone: NgZone) {
  }

  ngOnInit() {
    if(this.cart.cartDatas && this.api.userRole?.isCustomer) {
      this.cart.getStorageOLD();
      if(this.cart.cartDatas){
        if(Object.keys(this.cart.cartDatas).length) {
          this.cart.removeOneElementOLD('fromRoute');
        }
        if(!Object.keys(this.cart.cartDatas).length) {
          this.cart.removeStorageOLD();
        }
      }
    }

    if(this.api.userRole.isKiosk) this.nav.to('standby-kiosk');
    if(this.api.hasPerm(UserPermission.ALLOW_CONTROL) && !this.api.userRole?.isCustomer) {
      this.api.place(this.api.userPlaceId).then((res: Place) => {
        this.api.connectDailyOtp = res.connectDailyOtp ? res.connectDailyOtp : undefined;
      });
    }
    if(this.api.hasPerm(UserPermission.ALLOW_CONSUME) && !this.api.userRole?.isCustomer && this.api.env.type === DocumentType.ZWEVISA) {
      this.setForm();
    }

    this.request.checkIfPendingWaiting();
  }

  buttonClick(scenario: 'document' | 'person') {
    this.cart.setStorageOLD({fromRoute: scenario === 'document' ? 'document' : 'person'});
    if(scenario === 'document') {
      this.nav.to(this.cart.isShopping ? 'document-continue' : 'document-management');
    } else {
      this.nav.to('people');
    }
  }


  setForm() {
    this.form = this.formBuilder.group({
      entryConsume: ['', []],
      exitConsume: ['', []]
    });
    const consumeMode = localStorage.getItem('consumeMode');
    if(consumeMode && consumeMode === 'entry' || consumeMode === 'exit') {
      this.scanDocument.changeConsume(consumeMode, false, this.form);
    }
  }

  offlineLoader() {
    this.loader.loading(true, {type: 'warn', message: this.lang.transform('no.connection')});
  }

  clickScan() {
    if(this.deviceService.isDevices('cordova')) {
      permissions.checkPermission(permissions.CAMERA, (status: any) =>{
        if(status.hasPermission) {
          this.zone.run(() => {
            this.nav.to('scan-qr');
          });
        } else {
          this.zone.run(() => {
            this.nav.to('page-permission');
          });
        }
      });
    } else {
      this.nav.to('scan-qr');
    }
  }

  disconnect() {
    this.loader.loading(true, {type: 'warn', message: 'ask.disconnect', btnLabel: 'global.yes'}).then((done) => {
      if(done) {
        this.api.signOut();
      }
    });
  }

  goLatest() {
    if(this.scanDocument?.visaDatas?.length) {
      this.nav.to('admin-scanned-list');
    } else {
      this.scanDocument.scanDatas.id && this.nav.to('admin-request-select/' + this.scanDocument.scanDatas.id);
    }
  }

  protected readonly environment = environment;
  protected readonly DocumentType = DocumentType;
}
